import React, { useEffect, useState } from "react";
import { Typography, Grid, Box, TextField } from "@mui/material";

export default function PayslipDeductioin({handleInputChange,formData}) {
 

  return (
    <Grid container spacing={2}style={{marginBottom: "30px"}}>
      <Grid item xs={12} md={6} sm={6}>
        <Box className="typography-title">
          <Typography variant="h1" className="payslip-heading-h1">
            Deductions
          </Typography>
        </Box>
      </Grid>
      <Grid
        container
        spacing={3}
        sx={{ display: "flex", justifyContent: "center", mb: "15px" }}
      >
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="tax_deducted_at_source"
            fullWidth
            onChange={handleInputChange}
            value={formData.tax_deducted_at_source}
            label="Tax Deducted at Source (TDS)"
            type="number"
            color="secondary"
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="epf"
            fullWidth
            onChange={handleInputChange}
            value={formData.epf}
            label="EPF"
            required
            type="number"
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            fullWidth
            onChange={handleInputChange}
            name="health_insurance"
            label="Health Insurance"
            value={formData.health_insurance}
            type="number"
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5}>
          <TextField
            name="other_deductions"
            fullWidth
            onChange={handleInputChange}
            value={formData.other_deductions}
            label="Other Deductions"
            type="number"
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5} sx={{ textAlign: "left" }}>
          <TextField
            name="total_deductions"
            fullWidth
            onChange={handleInputChange}
            value={formData.total_deductions}
            label="Total Deductions"
            type="number"
            disabled
            required
          />
        </Grid>
        <Grid item xs={10} md={5} sm={5} sx={{ textAlign: "left" }}>

        </Grid>
      </Grid>
    </Grid>
  );
}
